import { Card, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

interface ProfileCardProps {
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

export default function ProfileCard({ children, className = '', dataTestId }: ProfileCardProps) {
  const classes = useStyles();
  return (
    <Card classes={{ root: classes.root }} className={className} elevation={0} data-testid={dataTestId}>
      {children}
    </Card>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    border: `solid 1px ${theme.palette.divider}`,
    //to-do, shared ui is lacking mui.d.ts which overrides and adds the shadow
    boxShadow: (theme.palette as any).shadow?.card ?? '0px 2px 9px rgba(0, 0, 0, 0.1)',
    overflow: 'visible',
  },
}));
